(() => {
  const mobileQuery = window.matchMedia('(max-width: 989px)');
  let gesture = null;

  function cardAtPoint(target, clientX, clientY) {
    const card = target.closest('.card-wrapper');
    if (!card) return null;
    const media = card.querySelector('.card__media');
    const images = media?.querySelectorAll('.media--hover-effect > img');
    if (!media || !images || images.length < 2) return null;
    const rect = media.getBoundingClientRect();
    const inside = clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom;
    return inside ? { card, media, images } : null;
  }

  document.addEventListener('pointerdown', (event) => {
    if (!mobileQuery.matches || (event.pointerType === 'mouse' && event.button !== 0)) return;
    const result = cardAtPoint(event.target, event.clientX, event.clientY);
    if (!result) return;
    gesture = {
      ...result,
      pointerId: event.pointerId,
      startX: event.clientX,
      startY: event.clientY,
      startScrollY: window.scrollY,
    };
  }, true);

  document.addEventListener('pointermove', (event) => {
    if (!gesture || gesture.pointerId !== event.pointerId) return;
    const deltaX = event.clientX - gesture.startX;
    const deltaY = event.clientY - gesture.startY;
    if (Math.abs(deltaY) > 8 && Math.abs(deltaY) > Math.abs(deltaX)) {
      gesture = null;
    }
  }, { capture: true, passive: true });

  async function showImage(card, images, showSecondary) {
    if (showSecondary) {
      images[1].loading = 'eager';
      try {
        if (!images[1].complete) await images[1].decode();
      } catch (_) {
        // A troca ainda pode acontecer caso o navegador não suporte decode().
      }
    }
    if (!card.isConnected) return;
    card.classList.toggle('sevenk-secondary-visible', showSecondary);
  }

  document.addEventListener('pointerup', async (event) => {
    if (!gesture || gesture.pointerId !== event.pointerId) return;
    const deltaX = event.clientX - gesture.startX;
    const deltaY = event.clientY - gesture.startY;
    const pageMoved = Math.abs(window.scrollY - gesture.startScrollY);
    const isTap = Math.abs(deltaX) < 6 && Math.abs(deltaY) < 6 && pageMoved < 2;
    const isHorizontalSwipe = Math.abs(deltaX) > 28 && Math.abs(deltaX) > Math.abs(deltaY) * 1.25;

    if (isTap || isHorizontalSwipe) {
      const { card, images } = gesture;
      const showSecondary = isHorizontalSwipe
        ? deltaX < 0
        : !card.classList.contains('sevenk-secondary-visible');
      if (isHorizontalSwipe) {
        event.preventDefault();
      }
      gesture = null;
      await showImage(card, images, showSecondary);
      return;
    }

    gesture = null;
  }, true);

  document.addEventListener('pointercancel', () => {
    gesture = null;
  }, true);

})();
